import { render } from "./SubmitDocuments.vue?vue&type=template&id=5d35d1ce&scoped=true&ts=true"
import script from "./SubmitDocuments.vue?vue&type=script&lang=ts"
export * from "./SubmitDocuments.vue?vue&type=script&lang=ts"

import "./SubmitDocuments.vue?vue&type=style&index=0&id=5d35d1ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d35d1ce"]])

export default __exports__